const ordenesdeproteccion = {

    BuscarOrdenDeProteccion: 'REGOP/Consultas/OrdenesDeProteccion/BuscarOrdenDeProteccion', 
}

const consultas = {
    
    ordenesdeproteccion: ordenesdeproteccion
}

export default consultas;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/REGOP/Sistema/Consultas/consultas.js
// module id = null
// module chunks = 